import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

export default class Button extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.string,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    type: 'button',
    onClick: () => {}
  }

  render() {
    const { label, type, onClick } = this.props;
    return (
      <div className="button__container">
        <button type={type} className="button type__button" onClick={onClick}>
          {label}
        </button>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/Button/Button.js